export default "__VITE_ASSET__e40748ef__"